import { isRef, ref } from 'vue';
import { kebabCase, isPlainObject } from 'lodash-es';
import Loading from './service';

const INSTANCE_KEY = Symbol('VixLoading');

const getAttributeName = name => {
  return `vix-loading-${kebabCase(name)}`;
};

function createInstance(el, binding) {
  // const vm = binding.instance;
  const getBindingProp = key =>
    isPlainObject(binding.value) ? binding.value[key] : undefined;
  const resolveExpression = key => ref(key);
  const getProp = name =>
    resolveExpression(
      getBindingProp(name) || el.getAttribute(getAttributeName(name))
    );
  const fullscreen =
    getBindingProp('fullscreen') ?? binding.modifiers.fullscreen;
  const options = {
    text: getProp('text'),
    svg: getProp('svg'),
    svgViewBox: getProp('svgViewBox'),
    background: getProp('background'),
    customClass: getProp('customClass'),
    fullscreen,
    target: getBindingProp('target') ?? (fullscreen ? undefined : el),
    body: getBindingProp('body') ?? binding.modifiers.body,
    lock: getBindingProp('lock') ?? binding.modifiers.lock
  };
  const instance = Loading(options);
  el[INSTANCE_KEY] = {
    options,
    instance
  };
}

function updateOptions(originalOptions, newOptions) {
  for (const key of Object.keys(originalOptions)) {
    if (isRef(originalOptions[key]))
      originalOptions[key].value = newOptions[key];
  }
}

const vLoading = {
  mounted(el, binding) {
    if (binding.value) {
      createInstance(el, binding);
    }
  },
  updated(el, binding) {
    const instance = el[INSTANCE_KEY];
    if (!binding.value) {
      instance?.instance.close();
      el[INSTANCE_KEY] = null;
      return;
    }
    if (!instance) createInstance(el, binding);
    else {
      updateOptions(
        instance.options,
        isPlainObject(binding.value)
          ? binding.value
          : {
              text: el.getAttribute(getAttributeName('text')),
              svg: el.getAttribute(getAttributeName('svg')),
              svgViewBox: el.getAttribute(getAttributeName('svgViewBox')),
              background: el.getAttribute(getAttributeName('background')),
              customClass: el.getAttribute(getAttributeName('customClass'))
            }
      );
    }
  },
  unmounted(el) {
    el[INSTANCE_KEY]?.instance.close();
    el[INSTANCE_KEY] = null;
  }
};

export default vLoading;
